var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.909,
    height: 24.285,
    viewBox: "0 0 30.909 24.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope-of-white-paper",
    transform: "translate(0 -54.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M30.1,55.628a2.657,2.657,0,0,0-1.949-.811H2.76a2.657,2.657,0,0,0-1.949.811A2.657,2.657,0,0,0,0,57.577V76.343a2.656,2.656,0,0,0,.811,1.949A2.656,2.656,0,0,0,2.76,79.1H28.149a2.768,2.768,0,0,0,2.76-2.76V57.577A2.657,2.657,0,0,0,30.1,55.628ZM28.7,76.342a.559.559,0,0,1-.552.552H2.76a.559.559,0,0,1-.552-.552V63.1A10.1,10.1,0,0,0,3.4,64.234q4.623,3.553,7.348,5.83.88.742,1.432,1.156a7.95,7.95,0,0,0,1.492.836,4.321,4.321,0,0,0,1.768.422h.034a4.32,4.32,0,0,0,1.768-.422,7.941,7.941,0,0,0,1.492-.836q.552-.414,1.432-1.156,2.725-2.277,7.348-5.83A10.046,10.046,0,0,0,28.7,63.1V76.342Zm0-18.317v.19a4.307,4.307,0,0,1-.8,2.268,8.113,8.113,0,0,1-1.733,1.992q-3.329,2.622-6.917,5.468l-.6.509q-.5.423-.793.647t-.767.543a4.6,4.6,0,0,1-.871.474,2.049,2.049,0,0,1-.742.155h-.034a2.05,2.05,0,0,1-.742-.155,4.6,4.6,0,0,1-.871-.474q-.474-.319-.767-.543t-.793-.647l-.6-.509Q8.072,65.1,4.743,62.475a6.037,6.037,0,0,1-2.535-4.9.56.56,0,0,1,.552-.552H28.149a.3.3,0,0,0,.241.043c.069-.023.121.02.155.129s.066.161.095.155.046.066.052.216.008.225.008.225v.233Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.f03017dad023d2a8f48355a4bb525a2b.svg";
export { ForwardRef as ReactComponent };